import { render, staticRenderFns } from "./SitioValidacionTanques.vue?vue&type=template&id=6cf870c2"
import script from "./SitioValidacionTanques.vue?vue&type=script&lang=js"
export * from "./SitioValidacionTanques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports